import React, { useEffect, useRef } from 'react'
// import { Spinner } from 'react-bootstrap'
import useGetEnvelopes from '../../hooks/useGetEnvelopes'
import { useAuth } from '../../modules/auth'
import { Spinner } from 'react-bootstrap'

type Props = {
    showModal: boolean
    closeModal: () => void
    envelopeId: string
    isSender:boolean
    status:string
}

const ViewEnvelopeModal: React.FC<Props> = ({
    showModal,
    closeModal,
    envelopeId,
    isSender,
    status
}: Props) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const { loadingEnvelope: loading, envelope, fetchEnvelope,fetchSignerEnvelope } = useGetEnvelopes()
    const {currentUser} = useAuth()
    const email = currentUser?.data?.user?.email

    useEffect(() => {
        if (envelopeId) {
            if (isSender) {
                fetchEnvelope(envelopeId);
            } else {
                fetchSignerEnvelope(envelopeId, email);
            }
        }
    }, [envelopeId])

    // Listen for DocuSign completion events
    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            // DocuSign sends messages when actions are completed
            if (event.origin.includes('docusign')) {
                const data = event.data;
                // Check for completion events
                if (
                    data?.event === 'signing_complete' ||
                    data?.event === 'cancel' ||
                    data?.event === 'decline' ||
                    data?.event === 'exception' ||
                    data?.event === 'fax_pending' ||
                    data?.event === 'session_end'
                ) {
                    // console.log('DocuSign event received:', data.event);
                    closeModal();
                }
            }
        };

        // Add message listener
        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [closeModal])

    // Detect iframe navigation errors (CSP violations)
    useEffect(() => {
        const iframe = iframeRef.current;
        if (!iframe) return;

        const handleIframeError = () => {
            // console.log('Iframe navigation blocked - closing modal');
            closeModal();
        };

        // Listen for load errors
        iframe.addEventListener('error', handleIframeError);

        return () => {
            iframe.removeEventListener('error', handleIframeError);
        };
    }, [envelope, closeModal])

    // Detect CSP violations specifically
    useEffect(() => {
        const handleCSPViolation = (event: SecurityPolicyViolationEvent) => {
            // Check if the violation is related to frame-src and involves localhost
            if (
                event.violatedDirective === 'frame-src' 
            ) {
                // console.log('CSP violation detected - DocuSign closed, closing modal');
                closeModal();
            }
        };

        document.addEventListener('securitypolicyviolation', handleCSPViolation);

        return () => {
            document.removeEventListener('securitypolicyviolation', handleCSPViolation);
        };
    }, [closeModal])
    // when envelope is fetched and contains a url, navigate to it
    useEffect(() => {
        if (envelope && status === 'created' ) {
            const url =  envelope?.url;
            // if envelope is an object with url and contains https, open in new tab
            if (typeof url === 'string' && url.includes('http')) {
                window.open(url, '_blank', 'noopener,noreferrer');
                // optionally close modal after navigation
                closeModal();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [envelope, isSender])
      if (showModal && loading) {
        return (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(0,0,0,0.6)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000
                }}
            >
                <Spinner animation="border" variant="primary" />
            </div>
        )
    }
        // Show modal content when loaded (success or error)
    if (showModal && !loading) {
        return (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(0,0,0,0.6)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000
                }}
            >
                <div
                    style={{
                        background: "#fff",
                        padding: 0,
                        borderRadius: "8px",
                        width: "80%",
                        height: "80%",
                        position: "relative"
                    }}
                >
                    {envelope?.url && envelope.url.includes("https://") ? (
                        <iframe
                            ref={iframeRef}
                            src={envelope?.url}
                            style={{ width: "100%", height: "100%", border: "none" }}
                            title="DocuSign Sender View"
                            sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation allow-top-navigation-by-user-activation"
                            allow="camera; microphone"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    ) : envelope ? (
                        <p className="d-flex align-items-center justify-content-center text-dark fs-1 w-100 h-100 mx-2 text-center">{envelope}</p>
                    ) : (
                        <p className="d-flex align-items-center justify-content-center text-danger fs-1 w-100 h-100 mx-2 text-center">
                           {envelope || 'Failed to load envelope. Please try again.'}
                        </p>
                    )}

                    <button
                        style={{
                            position: "absolute",
                            top: "10px",
                            left: "10px",
                            background: "#ff4d4f",
                            color: "#fff",
                            border: "none",
                            padding: "8px 12px",
                            borderRadius: "4px",
                            cursor: "pointer"
                        }}
                        onClick={closeModal}
                    >
                        Close
                    </button>
                </div>
            </div>
        )
    }

    return null
}

export default ViewEnvelopeModal
